// extracted by mini-css-extract-plugin
export default {"vipDetails":"vipDetails_vipDetails__6idlW","details_title":"vipDetails_details_title__nmcun","close":"vipDetails_close__xLG55","footer":"vipDetails_footer__POgi7"};